module.exports = __webpack_public_path__ + "css/dark.c2c0a114.css";